// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iWRA","type":"styles_type__1OpOT","choices":"styles_choices__2EmKX"};